module.exports = __webpack_public_path__ + "static/media/img6.04b0d510.png";